import { ENavItemType } from 'core/model/enums/nav-item.enum';
import { SideNavButton } from '../side-nav-button';
import { SideNavDivider } from '../side-nav-divider';
import { type INavLink, SideNavLink, type TSubNavLink } from '../side-nav-link';

import './side-nav-list.scss';

export interface INavItem {
  type: ENavItemType;
  link?: INavLink;
  action?: () => void;
  sublinks?: Array<TSubNavLink>;
}

interface ISideNavListProps {
  items: Array<INavItem>;
  currentPath: string;
}

const renderNavItem = (item: INavItem, currentPath: string) => {
  const isActive = item.link?.to ? currentPath.startsWith(item.link?.to) : false;

  if (item.type === ENavItemType.DIVIDER) return <SideNavDivider />;
  if (item.type === ENavItemType.BUTTON) return <SideNavButton isActive={isActive} link={item.link} />;
  if (item.type === ENavItemType.LINK && item.link) return <SideNavLink isActive={isActive} link={item.link} />;
};

export const SideNavList = ({ items, currentPath }: ISideNavListProps) => (
  <ul className="sidenav-list">
    {items.map((item, index) => (
      <li key={`nav-item-${index}`}>{renderNavItem(item, currentPath)}</li>
    ))}
  </ul>
);
